var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-badge',{attrs:{"value":_vm.showBadge,"offset-x":"20","offset-y":"20","color":"primary"},scopedSlots:_vm._u([{key:"badge",fn:function(){return [_c('span',[_vm._v(" "+_vm._s(_vm.numPositions)+" ")])]},proxy:true}])},[_c('AsiBtn',{attrs:{"icon":_vm.icons.canOrderSample},on:{"click":_vm.showSampleOrderForm}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }